import { chartColors, DASHBOARD_DATE_OPTIONS } from '~/utils/constants';

export { DASHBOARD_DATE_OPTIONS };

export const PRODUCT_COLORS = Object.values(chartColors);
export const DASHBOARD_PAGE_SIZE = 5;
export const SAVED_COST_PER_INVALID_ADDRESS = 0.63;
export const ACTIVE_ORDER_STATUSES = new Set(['processing', 'mailed']);
export const DASHBOARD_TOOLTIP_CLASSES = { tooltip: 'dashboard-tooltip' };

export const GETTING_STARTED_HIDDEN_STORAGE_KEY = 'dashboard:getting-started-hidden';

export const DASHBOARD_TABS = [
  {
    value: 'mail',
    label: 'Mail Tracking',
  },
  {
    value: 'contacts',
    label: 'Contacts',
  },
  {
    value: 'engagement',
    label: 'Engagement',
  },
];

export const DEFAULT_DASHBOARD_TAB = DASHBOARD_TABS[0].value;
export const DASHBOARD_TAB_VALUES = new Set(DASHBOARD_TABS.map((tab) => tab.value));

export const PERFORMANCE_MODES = [
  {
    value: 'mostMailed',
    label: 'Most mailed',
  },
  {
    value: 'highestPerforming',
    label: 'Highest performing templates',
  },
];
export const PERFORMANCE_VIEWS = ['templates', 'orders', 'campaigns'];
